import { IGoal } from "motw_core/Entity/IGoal";
import * as React from "react";
import { StyleClass } from "source/app/presentation/Shared/Styles/CSS";

export function GoalWeeklyRateAmount({
    allGoals,
    goalName,
}: {
    allGoals: IGoal[];
    goalName: string;
}) {
    const goal = allGoals.find((goal) => goal.name === goalName)!;

    const badgeStyleClass = StyleClass(`goalWeeklyRateAmountBadge`, {
        color: "white",
        background: "#2d2600",
        padding: "3px 6px",
        margin: "0px 5px",
        fontSize: "11px",
        borderRadius: "7px",
        float: `right`,
    });

    const tooltipText = `weekly rate: ${goal.weeklyrate}`;

    return (
        <span className={badgeStyleClass} data-tip={tooltipText}>
            {goal.weeklyrate}
        </span>
    );
}
